import React, { useState } from "react";

const FinalizeLegend = () => {
    const [expanded, setExpanded] = useState(true);

    return (
        <div className="legend">
            <div className="legend-header" style={{ marginBottom: expanded ? "10px" : 0 }} onClick={() => setExpanded(!expanded)}>
                Legenda <i className={`fa fa-chevron-${expanded ? "up" : "down"}`} />
            </div>
            {expanded && (
                <div className="legend-items-container">
                    <div className="legend-item">
                        <label className="finalize-custom-checkbox">
                            <input type="checkbox" readOnly disabled />
                            <i className="fa fa-check finalize-custom-checkmark" />
                        </label>
                        <span className="legend-description">Niet behaald</span>
                    </div>
                    <div className="legend-item">
                        <label className="finalize-custom-checkbox">
                            <input type="checkbox" readOnly checked />
                            <i style={{ color: "green" }} className="fa fa-check finalize-custom-checkmark" />
                        </label>
                        <span className="legend-description">Geselecteerd certificaat</span>
                    </div>
                    <div className="legend-item">
                        <label className="finalize-custom-checkbox">
                            <input type="checkbox" readOnly disabled />
                            <i style={{ color: "green" }} className="fa fa-check finalize-custom-checkmark" />
                        </label>
                        <span className="legend-description">Modulen/eindtermen verwerkt in bovenliggende certificering</span>
                    </div>
                    <div className="legend-item">
                        <label className="finalize-custom-checkbox">
                            <input type="checkbox" readOnly checked />
                            <i style={{ color: "#999" }} className="fa fa-check checkmark-already-certified" />
                        </label>
                        <span className="legend-description">(deel)certificering al aangemaakt</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FinalizeLegend;
